import React from 'react';

interface Props {
  style?: object;
  color?: string;
}

export default function IconArrow({ style, color = '#003A1B' }: Props) {
  return (
    <svg width="13px" height="8px" viewBox="0 0 13 8" version="1.1" xmlns="http://www.w3.org/2000/svg" style={style}>
      <g id="Symbols" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="square">
        <g id="Header" transform="translate(-57.000000, -17.000000)" stroke={color} strokeWidth="1.6">
          <g id="Shop">
            <g transform="translate(0.000000, 7.000000)">
              <path
                d="M66.3000004,13.4361216 L60.6555524,7.70347918 L66.3000004,13.4361216 L60.6555524,19.1687641 L66.3000004,13.4361216 Z M66.3000004,13.4361216 L66.3444476,13.4812634 L66.3000004,13.4361216 L66.3444476,13.3909799 L66.3000004,13.4361216 Z"
                id="Arrow"
                transform="translate(63.500000, 13.436122) rotate(-270.000000) translate(-63.500000, -13.436122) "
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
}
